import React from 'react'
import styles from "./Leaderboard.module.css"
import LeaderboardIcon from './images/Group 4492.svg'
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
interface LeaderboardEmptyprops{
    PrizePooltext?: string;
    NumberofEntries ?: number;
}
const LeaderboardEmpty: React.FC<LeaderboardEmptyprops>= (
    {PrizePooltext,NumberofEntries}
) => {
    const {t} = useTranslation();
  return (
    
    <div className={styles.EmptyLeaderboard}>
        <div className={styles.container}> 
            <div className={styles.EmptyLeaderboardicon}>
                <img 
                src={LeaderboardIcon}
                alt='sdsdsd'
                >
                </img>
            </div>
            <div className={clsx(styles.PrizePool , "fontWeightBold  fontSizeSm20")}>
                {PrizePooltext} {t("prizePool")}
            </div>
            <div className={clsx(styles.Entriesfilled , "fontSizeSm14 fontWeightRegular")}>
                {NumberofEntries} {t("entriesFilled")}
            </div>
        </div>
    </div>
  )
}

export default LeaderboardEmpty